import { render, staticRenderFns } from "./customerMsgReview.vue?vue&type=template&id=8ab9de8e&scoped=true&"
import script from "./customerMsgReview.vue?vue&type=script&lang=js&"
export * from "./customerMsgReview.vue?vue&type=script&lang=js&"
import style0 from "./customerMsgReview.vue?vue&type=style&index=0&id=8ab9de8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ab9de8e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8ab9de8e')) {
      api.createRecord('8ab9de8e', component.options)
    } else {
      api.reload('8ab9de8e', component.options)
    }
    module.hot.accept("./customerMsgReview.vue?vue&type=template&id=8ab9de8e&scoped=true&", function () {
      api.rerender('8ab9de8e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/customerService/customerMsgReview.vue"
export default component.exports